// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1rK6l"};